import React from "react";
import styles from "./Login.module.scss";
import { Text, type TextProps } from "@mantine/core";

export const ForgotPassword: React.FC<React.ComponentProps<typeof Text>> = ({
  children,
  className,
  ...rest
}) => (
  <Text className={`${styles.forgotPassword} ${className ?? ""}`} {...rest}>
    {children}
  </Text>
);

export const ForgotPasswordWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.forgotPasswordWrapper} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
